import * as React from "react";
import classNames from 'classnames';
import { store } from '../../../../store/index';
import { IInitialState, DataContext, WebchatLogoPosition } from '../../../../models/chat.models';
import { webChatService } from '../../../../services/webchat.service';

var Color = require('color');

export interface WebChatHeaderWelcomeProps { }

export const WebChatHeaderWelcome = (props: WebChatHeaderWelcomeProps) => {
  const context: IInitialState = React.useContext(DataContext);

  const cssContent = require('./header-welcome.css').toString();
  let personalizedCss = '';

  if (context.webChatSettings && context.webChatSettings.SecondaryTextColour) {
    
    const aphaSecondaryTextColour = Color(context.webChatSettings.SecondaryTextColour).alpha(0.7).rgb().string();

    personalizedCss = '\
    h1 .help-desk-header-welcome-title > span {\
      color: ' + context.webChatSettings.SecondaryTextColour + '; \
    }\
    h2 .help-desk-header-welcome-message > span {\
      color: ' + aphaSecondaryTextColour + '; \
    }';
  }

  function closeChat() {
    store.dispatch({ type: 'SET_CHAT_OPENED', payload: false });
  }

  return (
    <div className="help-desk-header-welcome">
      <style>
        {cssContent}
        {personalizedCss}
      </style>
      <div className="help-desk-close-header-button" role="button" onClick={() => closeChat()}>
        <div className="help-desk-close-button-svg">
          <svg viewBox="0 0 16 16" height="16">
            <path fill={context.webChatSettings && context.webChatSettings.SecondaryTextColour ? context.webChatSettings.SecondaryTextColour : '#FFF'} d="M13.978 12.637l-1.341 1.341L6.989 8.33l-5.648 5.648L0 12.637l5.648-5.648L0 1.341 1.341 0l5.648 5.648L12.637 0l1.341 1.341L8.33 6.989l5.648 5.648z" fillRule="evenodd">
            </path>
          </svg>
        </div>
      </div>
      <div className="help-desk-header-welcome-wrapper">
        <div className={classNames({ "help-desk-header-welcome-logo" : !context.webChatSettings || context.webChatSettings.LogoPosition == WebchatLogoPosition.Middle}, { 'help-desk-header-welcome-logo-left': context.webChatSettings && context.webChatSettings.LogoPosition == WebchatLogoPosition.Left }, { 'help-desk-header-welcome-logo-right': context.webChatSettings && context.webChatSettings.LogoPosition == WebchatLogoPosition.Right })}>
        { context.webChatSettings && context.webChatSettings.LogoUrl ? 
                                  <img src={ context.webChatSettings.LogoUrl } /> 
                                  :
          <svg id="svg" width="400" height="400" viewBox="0, 0, 400,400">
            <g>
              <path id="path0" d="M76.518 98.489 L 76.524 141.303 199.638 242.569 C 267.351 298.265,322.918 343.951,323.121 344.092 C 323.485 344.348,323.488 343.364,323.488 205.274 L 323.488 66.198 288.608 66.198 L 253.728 66.198 253.681 133.170 L 253.633 200.143 165.263 128.026 C 116.660 88.362,76.807 55.857,76.702 55.792 C 76.574 55.712,76.514 69.547,76.518 98.489 " stroke="none" fill="#fbfbfb" fillRule="evenodd"/>
              <path id="path1" d="M76.512 256.076 L 76.512 333.646 76.965 333.302 C 77.214 333.113,79.057 331.608,81.060 329.958 C 83.063 328.308,92.542 320.507,102.126 312.623 C 111.709 304.739,120.731 297.310,122.175 296.113 C 123.619 294.917,126.953 292.174,129.583 290.018 C 132.213 287.862,135.293 285.327,136.428 284.386 C 138.260 282.865,156.505 267.850,166.938 259.276 C 169.848 256.885,170.771 256.028,170.626 255.853 C 170.465 255.658,156.298 243.945,154.453 242.480 C 153.849 242.000,151.088 239.730,147.492 236.754 C 146.357 235.816,142.560 232.695,139.053 229.819 C 135.546 226.943,131.749 223.820,130.614 222.879 C 129.480 221.938,119.986 214.133,109.517 205.533 C 99.048 196.933,89.555 189.128,88.420 188.189 C 83.938 184.476,76.968 178.779,76.746 178.646 C 76.559 178.534,76.512 194.070,76.512 256.076 " stroke="none" fill="#f37c2c" fillRule="evenodd"/>
              <path id="path2" d="M0.000 200.000 L 0.000 400.000 200.000 400.000 L 400.000 400.000 400.000 200.000 L 400.000 0.000 200.000 0.000 L 0.000 0.000 0.000 200.000 M165.120 127.772 L 253.633 200.020 253.681 133.109 L 253.728 66.198 288.702 66.198 L 323.676 66.198 323.676 205.360 C 323.676 294.873,323.611 344.500,323.494 344.460 C 323.311 344.397,76.992 141.819,76.559 141.375 C 76.295 141.104,76.201 55.502,76.465 55.517 C 76.542 55.521,116.437 88.036,165.120 127.772 M124.519 217.798 C 149.944 238.702,170.770 255.877,170.801 255.965 C 170.851 256.108,76.827 333.615,76.604 333.615 C 76.553 333.615,76.512 298.670,76.512 255.960 L 76.512 178.305 77.403 179.048 C 77.893 179.457,99.095 196.895,124.519 217.798 " stroke="none" fill="#242c34" fillRule="evenodd"/>
              <path id="path3" d="M76.417 98.359 C 76.417 121.978,76.438 131.613,76.465 119.769 C 76.492 107.926,76.492 88.601,76.465 76.825 C 76.438 65.049,76.417 74.740,76.417 98.359 " stroke="none" fill="#67625e" fillRule="evenodd"/>
              <path id="path4" d="M323.535 205.215 C 323.497 316.438,323.441 344.299,323.254 344.194 C 323.068 344.089,323.067 344.113,323.251 344.311 C 323.378 344.448,323.525 344.516,323.579 344.463 C 323.632 344.410,323.655 281.757,323.629 205.235 L 323.582 66.104 323.535 205.215 " stroke="none" fill="#84848c" fillRule="evenodd"/>
            </g>
          </svg>
        }
        </div>
          <div className="help-desk-header-welcome-title">
            <span>{webChatService.getTranslations(1, context.webChatSettings)}</span>
          </div>
          <div className="help-desk-header-welcome-message">
            <span>
              {webChatService.getTranslations(2, context.webChatSettings)}
            </span>
          </div>
      </div>
    </div>
  )
}